import React from 'react'
import PropTypes from 'prop-types'
import { Redirect, Router, Route, Switch } from 'react-router-dom'

import { history } from './history'
import features from './config/features'
import routes from './config/routes'

import hasFeature from './utils/hasFeature'

import Search from './containers/Search/Search'
import SearchResults from './containers/Search/SearchResults'
import SeatTrade from './containers/SeatTrade/SeatTrade'
import TourOperatorSelector from './containers/TourOperator/TourOperatorSelector'
import GlobalMessage from './containers/GlobalMessage/GlobalMessage'
import EditBooking from './containers/EditBooking'

import TelemetryProvider from './components/TelemetryProvider'
import NewBookingContainer from './containers/NewBooking/NewBooking'
import ErrorBoundary from './components/ErrorBoundary'
import ActivateAccount from './components/ActivateAccount'
import AuthenticateUser from './components/AuthenticateUser'

const AppRouter = () => (
  <Router history={history}>
    <TelemetryProvider />
    <Switch>
      <Route
        exact
        path={routes.root}
        render={props => (
          <ErrorBoundary {...props}>
            <AuthenticateUser>
              {features.customTourOperatorSelection && <TourOperatorSelector />}
              <Search />
              <SearchResults />
              <GlobalMessage />
            </AuthenticateUser>
          </ErrorBoundary>
        )}
      />

      <Route
        exact
        path={routes.activateAccount}
        render={() => (
          <ErrorBoundary>
            <ActivateAccount />
          </ErrorBoundary>
        )}
      />

      <Route
        exact
        path={routes.editBooking}
        render={props => (
          <ErrorBoundary>
            <AuthenticateUser>
              <EditBooking {...props} />
              <GlobalMessage />
            </AuthenticateUser>
          </ErrorBoundary>
        )}
      />

      <Route
        exact
        path={routes.newBooking}
        render={props => (
          <ErrorBoundary>
            <AuthenticateUser>
              <NewBookingContainer {...props} />
              <GlobalMessage />
            </AuthenticateUser>
          </ErrorBoundary>
        )}
      />

      {hasFeature('seatTrade') && (
        <Route
          exact
          path={routes.trade}
          render={props => (
            <ErrorBoundary>
              <AuthenticateUser>
                {features.customTourOperatorSelection && (
                  <TourOperatorSelector />
                )}
                <SeatTrade {...props} />
                <GlobalMessage />
              </AuthenticateUser>
            </ErrorBoundary>
          )}
        />
      )}

      <Redirect to={routes.root} />
    </Switch>
  </Router>
)

export default AppRouter
